import { supabase } from '@/lib/supabase';

/**
 * Obtém sempre um token de acesso fresco.
 * Evita erros 401 causados por token expirado ou sessão ainda não inicializada.
 */
export async function getFreshToken(): Promise<string> {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token) return session.access_token;

  // Tentar refrescar a sessão automaticamente
  const { data: refreshed } = await supabase.auth.refreshSession();
  if (refreshed.session?.access_token) return refreshed.session.access_token;

  throw new Error('Sessão expirada. Por favor faz login novamente.');
}
